import LiveFeedback from './LiveFeedback';
import LiveDetailTabs from './LiveDetailTabs';
import SellerChatComposer from "./SellerChatComposer";
import ExpandableNotice from "../../../../Component/UI/ExpandableNotice";
import { sellerNoticeUpdated } from "../../../Broadcast/sellerNotice";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import io, { Socket } from "socket.io-client";
import api2 from "../../../../Component/axios_Interceptor/api2";
import { Live_rn_notice } from "../../../../Component/Interface/Live";
import url, { SOCKET_SERVER_URL } from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/admin_font";
import { RowView } from "../../../../Component/style/common_style";

const NotiFy = styled.div<{ $hasList: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.$hasList ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)'};
  width: 100%;
  min-width: 0;
  align-items: start;
  gap: 24px;
  @media (max-width: 720px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const InsertArea = styled.div`
  min-width: 0;
  textarea,
  input {
    flex: 0 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 1rem;
    ${fontStyles.regular}
    font-size: 16px;
    border: 1px solid var(--admin-theme-border, #f0f0f0);
    border-radius: 8px;
    outline: 0;
    resize: none;
    &:hover,
    &:focus {
      border: 1px solid var(--admin-theme-focus, #454545);
    }
    &::placeholder {
      color: var(--admin-theme-muted, #c6c6c6);
    }
  }
`;

const ScrollArea = styled.div`
  min-width: 0;
  width: 100%;
  max-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: var(--admin-theme-raised, #f8f8f8);
  }
  &::-webkit-scrollbar-thumb {
    background: var(--admin-theme-raised, #d9d9d9);
    &:hover {
      background: #bdbdbd;
    }
  }
`;
const Board = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  border-radius: 8px;
  div.title {
    margin: 0.5rem 0;
    ${fontStyles.semiBold}
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }
  div.gray {
    margin-top: 0.5rem;
    font-size: 14px;
    color: var(--admin-muted);
  }
  div.bar {
    width: 1px;
    height: 15px;
    margin: 0 0.5rem;
    background-color: var(--admin-theme-raised, #c6c6c6);
  }
  .gray button {
    padding: 4px;
    border: 0;
    background: transparent;
    color: var(--admin-theme-muted, #5f5868);
    font: inherit;
    cursor: pointer;
    &:hover { color: var(--admin-theme-link, #4f27bd); }
  }
`;

const FieldLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  color: var(--admin-theme-text, #45404e);
  ${fontStyles.medium}
  font-size: 14px;
`;

const CharacterCount = styled.p`
  margin: 6px 0 0;
  color: var(--admin-muted);
  font-size: 12px;
  line-height: 1.5;
  text-align: right;
`;
const SellerNoticeHelp = styled.p`
  margin: var(--space-2) 0 0; color: var(--color-text-secondary); font-size: var(--text-caption); line-height: var(--leading-caption);
`;

const SubmitNotice = styled.button`
  width: 100%;
  min-height: 46px;
  margin-top: 14px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--admin-accent), #4b20c2);
  color: #ffffff;
  ${fontStyles.semiBold}
  font-size: 15px;
  cursor: pointer;

  &:disabled { opacity: 0.6; cursor: wait; }
  &:focus-visible { outline: 3px solid var(--admin-theme-focus, #a993ef); outline-offset: 2px; }
`;

const Feedback = styled.p`
  margin: 12px 0 0;
  color: var(--admin-theme-success, #246b36);
  font-size: 14px;
  line-height: 1.5;
  &[role="alert"] { color: var(--admin-theme-danger, #b42318); }
`;

interface Notifyprops {
  onSaved?: () => void;
  notifyType: string;
  setNotifyType: React.Dispatch<React.SetStateAction<string>>;
}

const Detail_Notify = (props: Notifyprops) => {
  const { seq } = useParams();
  const notifyType = props.notifyType;
  const setNotifyType = props.setNotifyType;

  const [hasLn, setHasLn] = useState(false); // 등록된 ln이 있는지 여부
  const [ln_seq, setLn_seq] = useState<number | null>(null);
  const [ln_content, setLn_content] = useState("");
  const [sn_seq, setSn_seq] = useState<number | null>(null);
  const [sn_content, setSn_content] = useState("");
  const [rn_list, setRn_list] = useState<Live_rn_notice[]>([]);
  const [rn_seq, setRn_seq] = useState<number | null>(null);
  const [rn_title, setRn_title] = useState("");
  const [rn_content, setRn_content] = useState("");
  const [noticeBusy, setNoticeBusy] = useState(false);
  const [noticeError, setNoticeError] = useState("");
  const [noticeMessage, setNoticeMessage] = useState("");
  const [noticeLoading, setNoticeLoading] = useState(true);
  const [noticeLoadError, setNoticeLoadError] = useState("");
  const noticeRequestRef = useRef(0);
  const singleNotice = notifyType === "ln" || notifyType === "sn";
  const singleSeq = notifyType === "sn" ? sn_seq : ln_seq;
  const singleContent = notifyType === "sn" ? sn_content : ln_content;
  const hasSingleNotice = notifyType === "sn" ? sn_seq !== null : hasLn;

  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    let activeSocket: Socket | null = null;

    const initSocket = async () => {
      try {
        const res = await api2.get(url.Communication_url.get_live_info, {
          params: { seq: seq },
        });
        if (res.data && res.data.channel_name) {
          const newSocket = io(SOCKET_SERVER_URL, {
            path: "/socket.io",
            transports: ["websocket"],
          });

          newSocket.on("connect", () => {
            newSocket.emit("join-channel", { channelId: res.data.channel_name });
          });

          setSocket(newSocket);
          activeSocket = newSocket;
        }
      } catch (err) {
        console.error("소켓 초기화 실패:", err);
      }
    };

    initSocket();

    return () => {
      if (activeSocket) {
        activeSocket.disconnect();
      }
    };
  }, [seq]);

  const emitLiveNotice = async () => {
    try {
      const res = await api.get(url.Communication_url.get_live_notice, {
        params: { seq: seq, type: "ln" },
      });
      if (socket) {
        socket.emit("Live Notice", res.data);
      }
    } catch (e) {
      console.error("실시간 공지 발송 실패:", e);
    }
  };

  const setting_ln_contnet = (e: ChangeEvent<HTMLTextAreaElement>) =>
    notifyType === "sn" ? setSn_content(e.target.value) : setLn_content(e.target.value);
  const setting_rn_title = (e: ChangeEvent<HTMLInputElement>) =>
    setRn_title(e.target.value);
  const setting_rn_contnet = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setRn_content(e.target.value);

  const load_notice = async () => {
    const request = ++noticeRequestRef.current;
    const requestedType = notifyType;
    setNoticeLoading(true);
    setNoticeLoadError("");
    try {
      const res = await api.get(url.Communication_url.get_live_notice, {
        params: { seq: seq, type: requestedType },
      });
      if (request !== noticeRequestRef.current) return;
      if (!Array.isArray(res.data)) throw new Error("Invalid notice response");
      if (requestedType === "ln") {
        setLn_seq(res.data[0]?.seq || null);
        setLn_content(res.data[0]?.content || "");
        setHasLn(res.data.length !== 0);
      } else if (requestedType === "sn") {
        setSn_seq(res.data[0]?.seq || null);
        setSn_content(res.data[0]?.content || "");
      } else {
        setRn_list(res.data || []);
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      if (request === noticeRequestRef.current) setNoticeLoadError("공지사항을 불러오지 못했습니다. 다시 시도해주세요.");
    } finally {
      if (request === noticeRequestRef.current) setNoticeLoading(false);
    }
  };
  useEffect(() => {
    load_notice();
    return () => { noticeRequestRef.current += 1; };
  }, [notifyType, seq]);

  const noticeBtn = () => {
    if (noticeBusy) return;
    if ((singleNotice && hasSingleNotice) || (notifyType === "rn" && rn_seq)) {
      modify_notice();
      return;
    }
    insert_notice();
  };
  const insert_notice = async () => {
    if ((singleNotice && singleContent.trim() === "") ||
      (notifyType === "rn" && (rn_title.trim() === "" || rn_content.trim() === ""))) {
      setNoticeError(notifyType === "sn" ? "셀러 공지 내용을 입력해주세요." : notifyType === "ln" ? "긴급사항 내용을 입력해주세요." : "공지사항의 제목과 내용을 모두 입력해주세요.");
      return;
    }

    setNoticeBusy(true);
    setNoticeError("");
    setNoticeMessage("");
    try {
      const res = await api.post(url.Communication_url.create_live_notice, {
        live_seq: seq,
        type: notifyType,
        ...(singleNotice && { content: singleContent }),
        ...(notifyType === "rn" && { title: rn_title, content: rn_content }),
      });

      if (res.data !== "성공") throw new Error("Unexpected response");
      if (notifyType === "sn") sellerNoticeUpdated(Number(seq)); else emitLiveNotice();
      setNoticeMessage("공지가 등록되었습니다.");
      if (notifyType === "ln") setHasLn(true);
      if (notifyType === "rn") {
        setRn_title("");
        setRn_content("");
      }
      await load_notice();
      props.onSaved?.();
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      setNoticeError("공지를 등록하지 못했습니다. 다시 시도해주세요.");
    } finally {
      setNoticeBusy(false);
    }
  };
  const modify_notice = async () => {
    if (notifyType === "rn" && rn_content.trim() !== "" && rn_title.trim() === "") {
      setNoticeError("공지사항의 제목과 내용을 모두 입력해주세요.");
      return;
    }

    setNoticeBusy(true);
    setNoticeError("");
    setNoticeMessage("");
    try {
      const clearing = singleNotice ? !singleContent.trim() : !rn_content.trim();
      const res = clearing
        ? await api.delete(url.Communication_url.delete_live_notice, { data: { seq: singleNotice ? singleSeq : rn_seq } })
        : await api.patch(url.Communication_url.modify_live_notice, {
        ...(singleNotice && {
          seq: singleSeq,
          content: singleContent,
        }),
        ...(notifyType === "rn" && {
          seq: rn_seq,
          title: rn_title,
          content: rn_content,
        }),
      });

      if (res.data === "성공") {
        if (notifyType === "sn") sellerNoticeUpdated(Number(seq)); else emitLiveNotice();
        setNoticeMessage(clearing ? "공지가 삭제되었습니다." : "공지가 수정되었습니다.");
        await load_notice();
      props.onSaved?.();
      } else throw new Error("Unexpected response");
      if (notifyType === "rn") {
        setRn_title("");
        setRn_content("");
        setRn_seq(null);
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      setNoticeError("공지를 수정하지 못했습니다. 다시 시도해주세요.");
    } finally {
      setNoticeBusy(false);
    }
  };

  const modify_rn = async (title: string, content: string, seq: number) => {
    setRn_title(title);
    setRn_content(content);
    setRn_seq(seq);
  };
  const delete_rn = async (seq: number) => {
    if (noticeBusy) return;
    if (!window.confirm("정말 삭제하시겠습니까?")) {
      return;
    }

    setNoticeBusy(true);
    setNoticeError("");
    setNoticeMessage("");
    try {
      const res = await api.delete(url.Communication_url.delete_live_notice, {
        data: { seq: seq },
      });

      if (res.data === "성공") {
        setNoticeMessage("공지가 삭제되었습니다.");
        await load_notice();
      } else throw new Error("Unexpected response");
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
      setNoticeError("공지를 삭제하지 못했습니다. 다시 시도해주세요.");
    } finally {
      setNoticeBusy(false);
    }
  };

  return (
    <NotiFy $hasList={notifyType === "rn" && !noticeLoading && !noticeLoadError && rn_list.length > 0}>
      <InsertArea>
        <LiveDetailTabs role="tablist" aria-label="공지 유형">
            <button
              type="button"
              role="tab"
              aria-selected={notifyType === "ln"}
              onClick={() => setNotifyType("ln")}
            >
              긴급사항
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={notifyType === "rn"}
              onClick={() => setNotifyType("rn")}
            >
              공지사항
            </button>
            <button type="button" role="tab" aria-selected={notifyType === "sn"}
              onClick={() => setNotifyType("sn")}>
              셀러 채팅
            </button>
        </LiveDetailTabs>

        {notifyType === "sn" ? <SellerChatComposer liveSeq={Number(seq)} /> : <>
        {noticeLoading && <Feedback role="status">공지사항을 불러오는 중입니다.</Feedback>}
        {noticeLoadError && <Feedback as={LiveFeedback} role="alert">{noticeLoadError} <button type="button" onClick={load_notice}>다시 시도</button></Feedback>}

        {!noticeLoading && !noticeLoadError && (singleNotice ? (
          <>
          <FieldLabel>{notifyType !== "ln" && "공지 내용"}
          <textarea aria-label={notifyType === "ln" ? "공지 내용" : undefined}
            id={`${notifyType}-content`} aria-describedby={`${notifyType}-content-count`}
            style={{ height: "10rem" }}
            placeholder="내용을 입력해주세요."
            value={singleContent}
            onChange={setting_ln_contnet}
          />
          </FieldLabel>
          <CharacterCount id={`${notifyType}-content-count`}>{singleContent.length}자</CharacterCount>
          {notifyType === "sn" && <SellerNoticeHelp>셀러 송출 화면과 관리자 라이브 상세에 표시됩니다.</SellerNoticeHelp>}
          </>
        ) : (
          <>
            <FieldLabel>공지 제목
            <input
              id="rn-title" aria-describedby="rn-title-count"
              style={{ height: "3rem", marginBottom: "0.5rem" }}
              placeholder="제목을 입력해주세요."
              value={rn_title}
              onChange={setting_rn_title}
              maxLength={20}
            />
            </FieldLabel>
            <CharacterCount id="rn-title-count">{rn_title.length} / 20자 · 최대 20자</CharacterCount>
            <FieldLabel>공지 내용
            <textarea
              id="rn-content" aria-describedby="rn-content-count"
              style={{ height: "7rem" }}
              placeholder="내용을 입력해주세요."
              value={rn_content}
              onChange={setting_rn_contnet}
            />
            </FieldLabel>
            <CharacterCount id="rn-content-count">{rn_content.length}자</CharacterCount>
          </>
        ))}
        {noticeMessage && <Feedback as={LiveFeedback} role="status">{noticeMessage}</Feedback>}
        {noticeError && <Feedback as={LiveFeedback} role="alert">{noticeError}</Feedback>}
        <SubmitNotice type="button" disabled={noticeBusy || noticeLoading || Boolean(noticeLoadError)} onClick={noticeBtn}>
          {noticeBusy ? "저장 중..." : (notifyType === "rn" && rn_seq) || (singleNotice && hasSingleNotice) ? "공지 수정" : "공지 등록"}
        </SubmitNotice>
        </>}
      </InsertArea>

      {notifyType === "rn" && !noticeLoading && !noticeLoadError && rn_list.length > 0 && (
        <ScrollArea role="list" aria-label="공지사항 목록">
          {rn_list.map(data => {
            return (
              <Board key={data.seq} role="listitem">
                <div className="title">{data.title}</div>
                <ExpandableNotice content={data.content} previewLength={15} />
                <RowView className="gray">
                  <div>{data.crt_dt}</div>
                  <RowView>
                    <button type="button"
                      onClick={() =>
                        modify_rn(data.title, data.content, data.seq)
                      }
                    >
                      수정
                    </button>
                    <div className="bar" />
                    <button type="button" onClick={() => delete_rn(data.seq)}>삭제</button>
                  </RowView>
                </RowView>
              </Board>
            );
          })}
        </ScrollArea>
      )}
    </NotiFy>
  );
};

export default Detail_Notify;
